import EntityAttributeValue from './Models/EntityAttributeValue'

Vue.prototype.$models.$entityAttributeValue = new Vue(EntityAttributeValue)

Vue.component('eav-resource-table', () => import(/* webpackChunkName: "eav-resource-table" */ '@modulesPages/EAV/Resources/assets/js/Components/EAVResourceTable'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\EAV\\Entities\\EntityAttributeValue': 'Atributo Valor',
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\EAV\\Entities\\EntityAttributeValue': 'Atributos Valores',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'entity_attribute_values': 'Modules\\EAV\\Entities\\EntityAttributeValue',
	}	
}